/* Update cart items upsell */
if (!customElements.get('cart-item-upsell')) {
  class CartItemUpsell extends HTMLElement {
    constructor() {
      super();

      // Selectors
      this.steps = this.querySelectorAll('[data-cart-upsell-step]');
      this.primaryAnswer = this.querySelectorAll('[data-cart-upsell-primary-answer]');
      this.secondaryAnswer = this.querySelectorAll('[data-cart-upsell-secondary-answer]');
      this.closeButton = this.querySelector('[data-cart-upsell-close]');
      this.backButtons = this.querySelectorAll('[data-cart-upsell-back]');

      // Data attributes
      this.attributeName = this.dataset.cartUpsellAttribute;
      this.cartItemId = this.dataset.cartUpsellId;

      // State
      this.answer1 = null;
      this.answer2 = null;

      // Bind events
      this.primaryAnswer.forEach((button) => {
        button.addEventListener('click', (event) => {
          let answer = event.target.dataset.cartUpsellPrimaryAnswer;
          this.answer1 = answer;
          this.toggleStep(answer);
        });
      });

      this.secondaryAnswer.forEach((select) => {
        select.addEventListener('change', (event) => {
          let answer = event.target.value;
          this.answer2 = answer;
          this.toggleStep('thank-you');
          this.updateCartAttributes(answer);
        });
      });

      this.closeButton.addEventListener('click', (event) => {
        this.closeUpsell();
        if (!this.answer2) {
          this.updateCartAttributes('skipped');
        }
      });

      this.backButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          this.toggleStep('question');
        });
      });
    }

    /**
     * Toggle the step visibility
     * @param {string} stepName - The name of the step to toggle
     * @returns {void}
     */
    toggleStep(stepName) {
      this.steps.forEach((el) => {
        const step = el.dataset.cartUpsellStep;
        if (step === stepName) {
          el.classList.remove('hidden');
        } else {
          el.classList.add('hidden');
        }
      });
    }

    /**
     * Close the upsell
     * @returns {void}
     */
    closeUpsell() {
      this.classList.add('hidden');
    }

    /**
     * Update the cart attributes
     * @param {string} answer - The answer to the upsell question
     * @returns {void}
     */
    async updateCartAttributes(answer) {
      if (!answer || !this.attributeName) {
        return;
      }

      let body = JSON.stringify({
        attributes: {
          [this.attributeName]: answer,
        },
      });

      await fetch(routes.cart_update_url, { ...fetchConfig(), ...{ body } });
    }
  }

  customElements.define('cart-item-upsell', CartItemUpsell);
}

